import { useParams } from "wouter";
import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import { Calendar, User, ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import blogData from "@/data/blog.json";

export default function BlogPost() {
  const params = useParams();
  const slug = params.slug;
  
  const post = blogData.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Post Not Found</h1>
          <Link href="/blog">
            <Button>Back to Blog</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={`${post.title} - First Soft UAE Blog`}
        description={post.summary}
        keywords={`${post.category}, tech blog, software development`}
        ogImage={post.image}
        ogType="article"
      />

      <article className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link href="/blog">
              <Button variant="ghost" className="mb-8 hover:text-primary">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Blog
              </Button>
            </Link>

            <div className="max-w-4xl mx-auto">
              <div className="mb-8">
                <span className="px-3 py-1 bg-primary text-primary-foreground text-sm rounded-full">
                  {post.category}
                </span>
              </div>

              <h1 className="font-orbitron font-bold text-4xl md:text-5xl mb-6">
                {post.title}
              </h1>

              <div className="flex items-center space-x-6 text-muted-foreground mb-8">
                <div className="flex items-center space-x-2">
                  <Calendar className="h-5 w-5" />
                  <span>{new Date(post.date).toLocaleDateString()}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <User className="h-5 w-5" />
                  <span>{post.author}</span>
                </div>
              </div>

              <img
                src={post.image}
                alt={post.title}
                className="w-full h-64 md:h-96 object-cover rounded-xl mb-8"
                loading="lazy"
              />

              <div className="prose prose-lg prose-invert max-w-none">
                {post.body.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="mb-6 text-lg leading-relaxed text-muted-foreground">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="border-t border-border mt-12 pt-8">
                <h3 className="font-orbitron font-semibold text-xl mb-4">
                  Ready to discuss your project?
                </h3>
                <p className="text-muted-foreground mb-6">
                  Let's talk about how we can help bring your ideas to life.
                </p>
                <Link href="/contact">
                  <Button className="btn-primary">Get In Touch</Button>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </article>
    </>
  );
}
